import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, computed, ElementRef, input, output, viewChild } from '@angular/core';
import { ISwitchMenuItem } from '@libs/interfaces';
import { TranslateModule } from '@ngx-translate/core';
import { indexOf } from 'lodash';

@Component({
  selector: 'app-switch-menu',
  templateUrl: './switch-menu.component.html',
  styleUrls: ['./switch-menu.component.scss'],

  imports: [CommonModule, TranslateModule],
})
export class SwitchMenuComponent implements AfterViewInit {
  menu = input.required<ISwitchMenuItem[]>();
  size = input<'small' | 'normal'>('normal');
  width = input<string>('120');
  selected = input.required<ISwitchMenuItem>();
  background = input<'dark'>('dark');
  onselected = output<ISwitchMenuItem>();
  wrapper = viewChild<ElementRef>('wrapperSwitch');
  index = computed(() => indexOf(this.menu(), this.selected()));

  ngAfterViewInit(): void {
    this.wrapper().nativeElement.style.setProperty('--num-items', this.menu.length);
    this.wrapper().nativeElement.style.setProperty('--button-w', `${this.width()}px`);
  }
  setSelected(item: ISwitchMenuItem) {
    if (item != this.selected()) {
      this.onselected.emit(item);
    }
  }
}
